// @flow

import { action, makeAutoObservable, runInAction, computed } from 'mobx';
import jobsApi from 'core/api/jobs.api';

class IndustriesStore {
  jobs: any[] = [];
  totalRecords: number = 0;
  counts: number = 0;
  perPage: number = 9;
  loading: boolean = false;
  searchParams: any = {};
  page: number = 1;
  showFilters: boolean = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  @computed
  get pageCount(): number {
    return this.totalRecords / this.perPage;
  }

  @action.bound
  toggleVisibility() {
    this.showFilters = !this.showFilters;
  }

  @action.bound
  async getJobs(params: {} = {}) {
    this.loading = true;
    const { data, meta } = await jobsApi.fetch(params);

    runInAction(() => {
      this.loading = false;
      this.jobs = data;
      this.counts = meta.counts;
      this.totalRecords = meta.total_records;
    });
  }
}

export default new IndustriesStore();
